import {createSlice} from "@reduxjs/toolkit";
import _ from "lodash";

export const workflowSlice = createSlice({
    name: "workflow",
    initialState: {
        workflow: {
            type: null,
            data: {
                obsData: null
            }
        },
        workflowQueue: [],
        iPadSetting: {
            backend: true
        }
    },
    reducers: {
        setWorkflow: (state, preference) => {
            state.workflow = _.merge(state.workflow, preference.payload);
        },

        clearWorkflow: (state) => {
            state.workflow = {
                type: null,
                data: {}
            };
            state.workflowQueue = [];
        },

        addWorkflowStep: (state, steps) => {
            state.workflowQueue = [...state.workflowQueue,  ...steps.payload];
        },

        nextWorkflowStep: (state) => {
            let workflowTMP = _.clone(state.workflow);
            let workflowQueueTMP =  _.clone(state.workflowQueue) || [];

            if(workflowQueueTMP?.length) {
                workflowTMP.type = workflowQueueTMP.shift();

                state.workflow = workflowTMP;
                state.workflowQueue = workflowQueueTMP;
            } else {
                state.workflow = {
                    type: null,
                    data: {}
                };
            }
        },
        setIpadSetting: (state, preference) => {
            state.iPadSetting = _.merge(state.iPadSetting, preference.payload);
        },
    }
});

export const {
    setWorkflow,
    clearWorkflow,
    setIpadSetting,
    addWorkflowStep,
    nextWorkflowStep
} = workflowSlice.actions;

export const workflow = state => state.workflow.workflow;
export const workflowQueue = state => state.workflow.workflowQueue;
export const iPadSetting = state => state.workflow.iPadSetting;



export default workflowSlice.reducer;
